import buttonLoader from '../../utilities/buttonLoader.js';

var timetableManager = {};

timetableManager = {

  init: function () {

    var me = this;

    var datepicker = document.getElementById('timetableManager--datepicker');

    if (datepicker) {
      me.unRegisterClass.init();
      me.unRegisterCourse.init();
      me.register.init();
      me.changeTeacher.init();

      datepicker.onchange = function () {

        var val = this.value;

        window.location = window.location.origin + window.location.pathname + "?day=" + val;

      };
    }
      
  },

  unRegisterClass: {
    init: function () {
      var buttons = document.getElementsByClassName('timetableManager--unregister');
      var me = this;

      Array.prototype.forEach.call(buttons, function (button, index) {

        button.addEventListener('click', function (e) {
          e.preventDefault();

          me.submit(button);

        });

      });

    },
    submit: function (button) {

      var itemId = button.getAttribute('data-id');
      var ssn = button.getAttribute('data-ssn');

      buttonLoader.start(button);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'umbraco/surface/timetablemanager/unsubscribe?itemId=' + itemId + '&ssn=' + ssn);

      xhr.onload = function () {

        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {
            window.location.reload();

          } else {

            buttonLoader.reset(button);

            alert(resp.message);
          }

        } 

      };

      xhr.send();

    }
  },
  unRegisterCourse: {
    init: function () {
      var buttons = document.getElementsByClassName('timetableManager--courseUnregister');
      var me = this;

      Array.prototype.forEach.call(buttons, function (button, index) {

        button.addEventListener('click', function (e) {
          e.preventDefault();

          me.submit(button);

        });

      });

    },
    submit: function (button) {

      var itemId = button.getAttribute('data-id');
      var ssn = button.getAttribute('data-ssn');
      var occuranceId = button.getAttribute('data-courseId');

      buttonLoader.start(button);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/umbraco/surface/timetablemanager/UnsubscribeCourse?itemId=' + itemId + '&ssn=' + ssn + '&occuranceId=' + occuranceId);

      xhr.onload = function () {

        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {
            window.location.reload();

          } else {

            buttonLoader.reset(button);

            alert(resp.message);
          }

        }

      };

      xhr.send();

    }
  },
  register: {
    init: function() {
      var buttons = document.getElementsByClassName('timetableManager--register');
      var me = this;

      Array.prototype.forEach.call(buttons, function (button, index) {

        button.addEventListener('click', function (e) {
          e.preventDefault();


          me.dialog(button);

        });

      });

      var forms = document.getElementsByTagName('form');

      Array.prototype.forEach.call(forms, function (form, index) {

        if (!form.classList.contains("form-getlist")) {
          
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            me.submit(form);

          });
        }

      });

    },
    dialog: function(button) {

      var type = button.getAttribute('data-type');

      if (type === "Course") {
        var courseModal = document.getElementsByClassName('timetableManager--courseRegister')[0];

        if (courseModal) {
          courseModal.classList.add('modal--show');

          courseModal.querySelector('input[name=itemId]').value = button.getAttribute('data-id');

        }
      } else {
        var classModal = document.getElementsByClassName('timetableManager--classRegister')[0];

        if (classModal) {
          classModal.classList.add('modal--show');

          classModal.querySelector("input[name=itemId]").value = button.getAttribute('data-id');
        }
      }
    },
    submit: function(form) {

      var button = form.getElementsByTagName('button')[0];

      buttonLoader.start(button);

      var data = new FormData(form);

      var xhr = new XMLHttpRequest();
      xhr.open(form.getAttribute("method"), form.getAttribute("action"));

      xhr.onload = function () {

        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {

            window.location.reload();

          } else {

            buttonLoader.reset(button);

            alert(resp.message);

          }

        }

      };

      xhr.send(data);

    }
  },
  changeTeacher: {
    init: function () {
      var buttons = document.getElementsByClassName('timetableManager--changeTeacher');
      var form = document.getElementsByClassName('timetableManager--changeTeacherForm')[0];
      var me = this;

      Array.prototype.forEach.call(buttons, function (button, index) {

        button.addEventListener('click', function (e) {
          e.preventDefault();

          var dialog = document.getElementsByClassName('timetableManager--changeTeacherDialog')[0];

          if (dialog) {
            dialog.classList.add('modal--show');

            dialog.querySelector('input[name=itemId]').value = button.getAttribute('data-id');

            dialog.querySelector('select[name=teacher]').value = button.getAttribute('data-teacher');
            dialog.querySelector('select[name=extraTeacher]').value = button.getAttribute('data-extraTeacher');
          }

        });

      });

      if (form) {
        me.submit(form);
      }
    },
    submit: function (form) {


      form.addEventListener('submit', function (e) {
        var data = new FormData(form);

        var xhr = new XMLHttpRequest();
        xhr.open(form.getAttribute("method"), form.getAttribute("action"));

        xhr.onload = function () {

          var resp = JSON.parse(xhr.response);

          if (xhr.status >= 200 && xhr.status < 300) {

            if (resp.success) {

              window.location.reload();

            } else {

              alert(resp.message);

            }

          }

        };

        xhr.send(data);
      });



    }
  }
};

timetableManager.initialize = function () {
  timetableManager.init();
};

module.exports = timetableManager;
